import { render } from "./EditManager.vue?vue&type=template&id=4b1ed717&scoped=true"
import script from "./EditManager.vue?vue&type=script&lang=js"
export * from "./EditManager.vue?vue&type=script&lang=js"

import "./EditManager.vue?vue&type=style&index=0&id=4b1ed717&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b1ed717"]])

export default __exports__